export default "__VITE_ASSET__e70b2382__"